import {Actions, concatLatestFrom, createEffect, ofType} from '@ngrx/effects';
import * as fromActions from './core.actions';
import {exhaustMap, filter, map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {LoggedUserDataModel} from '../modules/rest/user/response/logged-user-data.model';
import {UserRestService} from '../modules/rest/user/user-rest.service';
import {loggedUserDataSelector} from '@core/store/core.reducer';
import {AppState} from '@core/reducers';
import {Store} from '@ngrx/store';

@Injectable()
export class CoreEffects {

    constructor(private actions$: Actions, private userRestService: UserRestService, private store: Store<AppState>) {
    }

    getLoggedUserData$ = createEffect(() => {
            return this.actions$.pipe(
                ofType(fromActions.GetLoggedUserData),
                exhaustMap(() => {
                    return this.userRestService.getLoggedUser()
                        .pipe(
                            map((loggedUserData: LoggedUserDataModel) => fromActions.GetLoggedUserDataSuccess({loggedUserData}))
                        );
                })
            );
        }
    );

    loadUserDataIfNotLoaded$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fromActions.WizardOpened, fromActions.ConsentOpened, fromActions.AnamnesisOpened, fromActions.PatientOverviewOpened),
            concatLatestFrom(() => this.store.select(loggedUserDataSelector)),
            filter(([, loggedUserData]) => !loggedUserData),
            exhaustMap(() => {
                return this.userRestService.getLoggedUser()
                    .pipe(
                        map((loggedUserData) => fromActions.GetLoggedUserDataSuccess({loggedUserData}))
                    );
            })
        );
    });

    updateUserPersonalSettings$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(fromActions.UpdateUserPersonalSettings),
            exhaustMap((action: ReturnType<typeof fromActions.UpdateUserPersonalSettings>) => {
                return this.userRestService.updatePersonalSettings(action.settings)
                    .pipe(
                        map(() => fromActions.UpdateUserPersonalSettingsSuccess({settings: action.settings}))
                    );
            })
        );
    });
}
